const buddy = confetti.shapeFromPath({
  path: 'M6 3V0H20V3H10V6H6V9H3V22H0V6H3V3H6ZM29 12V22H26V25H23V29H9V25H6V22H3V28H6V32H26V28H29V25H32V12H29ZM26 6V12H29V6H26ZM20 6V3H26V6H20ZM20 6V10H17V6H20ZM6 9H9V14H6V9ZM20 14H16V16H11V19H8V22H10V25H20V23H23V19H24V16H25V13H20V14ZM21 18H17V20H15V23H18V21H21V18Z',
  fillRule: 'evenodd',
});

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}

class buddyButton extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button');

    button.addEventListener('click', () => {
      confetti({
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 1000,
        particleCount: randomInRange(50, 100),
        origin: {
          x: randomInRange(0.1, 0.9),
          y: Math.random() - 0.2,
        },
        shapes: [buddy],
        flat: true,
        scalar: 3,
        colors: ['F26F21', '076370', '6BABA4', 'D8D4CF', '4C3974', '6D5C8D', '88211C', 'FFFFFF'],
      });
    });
  }
}

customElements.define('buddy-button', buddyButton);
